const GRID_DAYS = 42;
const WEEK_DAYS = 7;
export const BUSINESS_TIME_ZONE = 'America/New_York';

function pad(value) {
  return String(value).padStart(2, '0');
}

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}

function endOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}

function addDays(date, days) {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
}

export function formatCalendarDayKey(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function formatBusinessDayKey(value, timeZone = BUSINESS_TIME_ZONE) {
  const date = value instanceof Date ? value : new Date(value);
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date).reduce((acc, part) => {
    if (part.type !== 'literal') acc[part.type] = part.value;
    return acc;
  }, {});

  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function getMonthGridStart(monthDate) {
  const firstOfMonth = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
  return addDays(firstOfMonth, -firstOfMonth.getDay());
}

export function buildMonthMatrix(monthDate, today = new Date()) {
  const month = monthDate.getMonth();
  const gridStart = getMonthGridStart(monthDate);
  const todayKey = formatCalendarDayKey(today);
  const days = Array.from({ length: GRID_DAYS }, (_, index) => {
    const date = addDays(gridStart, index);
    const key = formatCalendarDayKey(date);
    return {
      date,
      key,
      label: date.getDate(),
      isCurrentMonth: date.getMonth() === month,
      isToday: key === todayKey,
    };
  });

  return Array.from({ length: GRID_DAYS / WEEK_DAYS }, (_, weekIndex) => (
    days.slice(weekIndex * WEEK_DAYS, weekIndex * WEEK_DAYS + WEEK_DAYS)
  ));
}

export function getCalendarRange(monthDate) {
  const gridStart = getMonthGridStart(monthDate);
  const gridEnd = addDays(gridStart, GRID_DAYS - 1);
  return {
    from: startOfDay(gridStart).toISOString(),
    to: endOfDay(gridEnd).toISOString(),
  };
}

export function sortEventsByStart(events = []) {
  return [...events].sort((left, right) => new Date(left.start).getTime() - new Date(right.start).getTime());
}

export function groupEventsByDay(events = []) {
  return sortEventsByStart(events).reduce((groups, event) => {
    const key = formatBusinessDayKey(event.start);
    return {
      ...groups,
      [key]: [...(groups[key] || []), event],
    };
  }, {});
}

export function getEventsForDay(groupedEvents, dateOrKey) {
  const key = typeof dateOrKey === 'string' ? dateOrKey : formatCalendarDayKey(dateOrKey);
  return groupedEvents[key] || [];
}

export function getEventApplicantUrl(event) {
  return event?.applicantUrl || (event?.applicantId ? `/applicants/${event.applicantId}` : null);
}
